import axios from 'axios'
import CreateSubDepartment from './dto/CreateSubDepartment'
import {EntityDto} from '../../../../../services/dto/entityDto'
import {PagedSubDepartmentResultRequestDto} from './dto/PagedSubDepartmentResultRequestDto'
import {PagedResultDto} from '../../../../../services/dto/pagedResultDto'
import GetAllSubDepartments from './dto/GetAllSubDepartments'
import UpdateSubDepartment from './dto/UpdateSubDepartment'
import GetSubDepartment from './dto/GetSubDepartment'

const API_URL = process.env.REACT_APP_SERVICE_API_URL
export const URL_CREATE = `${API_URL}/SubDepartment/Create`
export const URL_DELETE = `${API_URL}/SubDepartment/Delete`
export const URL_GET = `${API_URL}/SubDepartment/Get`
export const URL_GET_ALL = `${API_URL}/SubDepartment/GetPagedAll`
export const URL_UPDATE = `${API_URL}/SubDepartment/Update`

export function onCreateSubDepartment(createSubDepartment: CreateSubDepartment): Promise<boolean> {
  return axios.post(URL_CREATE, createSubDepartment)
}

export function onDeleteSubDepartment(entityDto: EntityDto): Promise<boolean> {
  return axios.delete(URL_DELETE, {params: entityDto})
}

export function onGetSubDepartment(entityDto: EntityDto): Promise<GetSubDepartment> {
  return axios.get(URL_GET, {params: entityDto})
}

export function onGetPagedAllSubDepartments(
  pagedFilterAndSortedRequest: PagedSubDepartmentResultRequestDto
): Promise<PagedResultDto<GetAllSubDepartments>> {
  return axios.get(URL_GET_ALL, {params: pagedFilterAndSortedRequest})
}

export function onUpdateSubDepartment(
  updateSubDepartmentInput: UpdateSubDepartment
): Promise<boolean> {
  return axios.put(URL_UPDATE, updateSubDepartmentInput)
}
